import React from "react";

import Box from "@mui/material/Box";
import Link from "@mui/material/Link";
import Paper from "@mui/material/Paper";
import Typography from "@mui/material/Typography";

import { ReactComponent as BottomBannerBg } from "assets/images/iban-qr-img-bg.svg";

import analytics from "services/analytics";
import { AnalyticsEvents } from "shared/constants/analytics";

import { styles } from "./styles";

interface BottomBannerProps {
  isPreview?: boolean;
}

const BottomBanner: React.FC<BottomBannerProps> = ({ isPreview }) => {
  const onTryIbanOplata = () => {
    !isPreview &&
      analytics().sendConversionEvent(
        AnalyticsEvents.iban_qr_try_iban_oplata,
        null,
        true
      );
  };

  return (
    <Paper elevation={5} sx={styles.banerPaper}>
      <Box sx={styles.banerImage}>
        <BottomBannerBg />
      </Box>
      <Box sx={styles.banerContent}>
        <Typography sx={{ mb: 0.5 }}>Лінки на оплату — це зручно!</Typography>
        <Typography variant="body2" sx={{ mb: 2 }}>
          Генеруйте зручні лінки для оплати та надсилайте їх клієнтам.
        </Typography>
        <Link
          href={
            "/?utm_source=internal&utm_medium=iban-qr&utm_content=human-bottom-banner"
          }
          target="_blank"
          underline="none"
          onClick={onTryIbanOplata}
        >
          Спробувати зараз
        </Link>
      </Box>
    </Paper>
  );
};

export default BottomBanner;
